"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationDto = instanceOfNotificationDto;
exports.NotificationDtoFromJSON = NotificationDtoFromJSON;
exports.NotificationDtoFromJSONTyped = NotificationDtoFromJSONTyped;
exports.NotificationDtoToJSON = NotificationDtoToJSON;
exports.NotificationDtoToJSONTyped = NotificationDtoToJSONTyped;
var NotificationEntityRefDto_1 = require("./NotificationEntityRefDto");
/**
 * Check if a given object implements the NotificationDto interface.
 */
function instanceOfNotificationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    if (!('deepLinkUrl' in value) || value['deepLinkUrl'] === undefined)
        return false;
    if (!('isRead' in value) || value['isRead'] === undefined)
        return false;
    if (!('readAt' in value) || value['readAt'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('priority' in value) || value['priority'] === undefined)
        return false;
    if (!('entityRef' in value) || value['entityRef'] === undefined)
        return false;
    if (!('metadata' in value) || value['metadata'] === undefined)
        return false;
    return true;
}
function NotificationDtoFromJSON(json) {
    return NotificationDtoFromJSONTyped(json, false);
}
function NotificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'title': json['title'],
        'body': json['body'],
        'deepLinkUrl': json['deepLinkUrl'],
        'isRead': json['isRead'],
        'readAt': json['readAt'],
        'createdAt': json['createdAt'],
        'priority': json['priority'],
        'entityRef': (0, NotificationEntityRefDto_1.NotificationEntityRefDtoFromJSON)(json['entityRef']),
        'metadata': json['metadata'],
    };
}
function NotificationDtoToJSON(json) {
    return NotificationDtoToJSONTyped(json, false);
}
function NotificationDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'title': value['title'],
        'body': value['body'],
        'deepLinkUrl': value['deepLinkUrl'],
        'isRead': value['isRead'],
        'readAt': value['readAt'],
        'createdAt': value['createdAt'],
        'priority': value['priority'],
        'entityRef': (0, NotificationEntityRefDto_1.NotificationEntityRefDtoToJSON)(value['entityRef']),
        'metadata': value['metadata'],
    };
}
